import config from '../config';
import { authHeader, handleResponse, commonRequestOptions, customFetch } from '../helpers';

const endpointPath = config.api.API_URL + '/dataset_lineage';

export const datasetLineageService = {
  getByObjectId,
  getRelatedDatasets,
};

function getByObjectId(objectName, objectId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/get_by_object_id/${objectName}/${objectId}`,
    requestOptions,
    signal
  ).then(handleResponse);
}
function getRelatedDatasets(datasetId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/get_related_datasets/${datasetId}`,
    requestOptions,
    signal
  ).then(handleResponse);
}
